import { IDialogProps } from "./interfaces/dialog.interfaces";
import { Box, Button, Dialog as MuiDialog } from "@mui/material";
import { useDialogProps } from "./hooks/useDialog";

export const Dialog = ({
    open,
    onClose,
    children,
    styles,
    config,
    dismissible = true,
    primaryButton,
    secondaryButton,
}: IDialogProps) => {
    const { dialogConfig, dialogSx, handleClose, getButtonProps } = useDialogProps({ onClose, styles, config, dismissible });

    return (
        <MuiDialog
            open={open}
            onClose={handleClose}
            disableEscapeKeyDown={!dismissible}
            sx={dialogSx}
            PaperProps={{ sx: dialogConfig.styles?.paper }}
        >
            <Box sx={dialogConfig.styles?.content}>{children}</Box>
            {(primaryButton || secondaryButton) && (
                <Box sx={dialogConfig.styles?.actions}>
                    {secondaryButton?.onClick && secondaryButton.label && <Button {...getButtonProps(secondaryButton)}>{secondaryButton.label}</Button>}
                    {primaryButton?.onClick && primaryButton.label && <Button {...getButtonProps(primaryButton)}>{primaryButton.label}</Button>}
                </Box>
            )}
        </MuiDialog>
    );
};

export { createDialogConfig, defaultDialogConfig } from "./config/dialog.config";
export type { DialogConfigOverride, IDialogConfig, IDialogProps, IButtonProps } from "./interfaces/dialog.interfaces";
